import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SupportedLanguages } from '@/types/supportedLanguages';

// Base language imports
import enTranslation from './supportedLanguages/en.json';
import amTranslation from './supportedLanguages/am.json';
import arTranslation from './supportedLanguages/ar.json';
import bnTranslation from './supportedLanguages/bn.json';
import deTranslation from './supportedLanguages/de.json';
import elTranslation from './supportedLanguages/el.json';
import esTranslation from './supportedLanguages/es.json';
import faTranslation from './supportedLanguages/fa.json';
import frTranslation from './supportedLanguages/fr.json';
import guTranslation from './supportedLanguages/gu.json';
import heTranslation from './supportedLanguages/he.json';
import hiTranslation from './supportedLanguages/hi.json';
import hmnTranslation from './supportedLanguages/hmn.json';
import htTranslation from './supportedLanguages/ht.json';
import hyTranslation from './supportedLanguages/hy.json';
import itTranslation from './supportedLanguages/it.json';
import jaTranslation from './supportedLanguages/ja.json';
import kmTranslation from './supportedLanguages/km.json';
import koTranslation from './supportedLanguages/ko.json';
import myTranslation from './supportedLanguages/my.json';
import nlTranslation from './supportedLanguages/nl.json';
import omTranslation from './supportedLanguages/om.json';
import paTranslation from './supportedLanguages/pa.json';
import plTranslation from './supportedLanguages/pl.json';
import psTranslation from './supportedLanguages/ps.json';
import ptTranslation from './supportedLanguages/pt.json';
import roTranslation from './supportedLanguages/ro.json';
import ruTranslation from './supportedLanguages/ru.json';
import soTranslation from './supportedLanguages/so.json';
import swTranslation from './supportedLanguages/sw.json';
import taTranslation from './supportedLanguages/ta.json';
import thTranslation from './supportedLanguages/th.json';
import tlTranslation from './supportedLanguages/tl.json';
import trTranslation from './supportedLanguages/tr.json';
import ukTranslation from './supportedLanguages/uk.json';
import urTranslation from './supportedLanguages/ur.json';
import viTranslation from './supportedLanguages/vi.json';
import yiTranslation from './supportedLanguages/yi.json';
import yoTranslation from './supportedLanguages/yo.json';
import zhCNTranslation from './supportedLanguages/zh-CN.json';
import zhTWTranslation from './supportedLanguages/zh-TW.json';

// Country-specific language imports
import amETTranslation from './supportedLanguages/am-ET.json';
import arAETranslation from './supportedLanguages/ar-AE.json';
import arSATranslation from './supportedLanguages/ar-SA.json';
import bgBGTranslation from './supportedLanguages/bg-BG.json';
import bnBDTranslation from './supportedLanguages/bn-BD.json';
import bsBATranslation from './supportedLanguages/bs-BA.json';
import csCZTranslation from './supportedLanguages/cs-CZ.json';
import cyGBTranslation from './supportedLanguages/cy-GB.json';
import daDKTranslation from './supportedLanguages/da-DK.json';
import deATTranslation from './supportedLanguages/de-AT.json';
import deCHTranslation from './supportedLanguages/de-CH.json';
import deDETranslation from './supportedLanguages/de-DE.json';
import elGRTranslation from './supportedLanguages/el-GR.json';
import enAUTranslation from './supportedLanguages/en-AU.json';
import enCATranslation from './supportedLanguages/en-CA.json';
import enGBTranslation from './supportedLanguages/en-GB.json';
import enIETranslation from './supportedLanguages/en-IE.json';
import enNZTranslation from './supportedLanguages/en-NZ.json';
import enUSTranslation from './supportedLanguages/en-US.json';
import esARTranslation from './supportedLanguages/es-AR.json';
import esCOTranslation from './supportedLanguages/es-CO.json';
import esESTranslation from './supportedLanguages/es-ES.json';
import esMXTranslation from './supportedLanguages/es-MX.json';
import esUSTranslation from './supportedLanguages/es-US.json';
import etEETranslation from './supportedLanguages/et-EE.json';
import faIRTranslation from './supportedLanguages/fa-IR.json';
import fiFITranslation from './supportedLanguages/fi-FI.json';
import frCATranslation from './supportedLanguages/fr-CA.json';
import frFRTranslation from './supportedLanguages/fr-FR.json';
import gaIETranslation from './supportedLanguages/ga-IE.json';
import guINTranslation from './supportedLanguages/gu-IN.json';
import heILTranslation from './supportedLanguages/he-IL.json';
import hiINTranslation from './supportedLanguages/hi-IN.json';
import hrHRTranslation from './supportedLanguages/hr-HR.json';
import htHTTranslation from './supportedLanguages/ht-HT.json';
import huHUTranslation from './supportedLanguages/hu-HU.json';
import hyAMTranslation from './supportedLanguages/hy-AM.json';
import idIDTranslation from './supportedLanguages/id-ID.json';
import isISTranslation from './supportedLanguages/is-IS.json';
import itITTranslation from './supportedLanguages/it-IT.json';
import jaJPTranslation from './supportedLanguages/ja-JP.json';
import kaGETranslation from './supportedLanguages/ka-GE.json';
import kmKHTranslation from './supportedLanguages/km-KH.json';
import koKRTranslation from './supportedLanguages/ko-KR.json';
import ltLTTranslation from './supportedLanguages/lt-LT.json';
import lvLVTranslation from './supportedLanguages/lv-LV.json';
import msMYTranslation from './supportedLanguages/ms-MY.json';
import mtMTTranslation from './supportedLanguages/mt-MT.json';
import myMMTranslation from './supportedLanguages/my-MM.json';
import nlBETranslation from './supportedLanguages/nl-BE.json';
import nlNLTranslation from './supportedLanguages/nl-NL.json';
import noNOTranslation from './supportedLanguages/no-NO.json';
import paINTranslation from './supportedLanguages/pa-IN.json';
import plPLTranslation from './supportedLanguages/pl-PL.json';
import psAFTranslation from './supportedLanguages/ps-AF.json';
import ptBRTranslation from './supportedLanguages/pt-BR.json';
import ptPTTranslation from './supportedLanguages/pt-PT.json';
import roROTranslation from './supportedLanguages/ro-RO.json';
import ruRUTranslation from './supportedLanguages/ru-RU.json';
import skSKTranslation from './supportedLanguages/sk-SK.json';
import slSITranslation from './supportedLanguages/sl-SI.json';
import soSOTranslation from './supportedLanguages/so-SO.json';
import sqALTranslation from './supportedLanguages/sq-AL.json';
import srRSTranslation from './supportedLanguages/sr-RS.json';
import svSETranslation from './supportedLanguages/sv-SE.json';
import swKETranslation from './supportedLanguages/sw-KE.json';
import taINTranslation from './supportedLanguages/ta-IN.json';
import thTHTranslation from './supportedLanguages/th-TH.json';
import tlPHTranslation from './supportedLanguages/tl-PH.json';
import trTRTranslation from './supportedLanguages/tr-TR.json';
import ukUATranslation from './supportedLanguages/uk-UA.json';
import urPKTranslation from './supportedLanguages/ur-PK.json';
import viVNTranslation from './supportedLanguages/vi-VN.json';
import yoNGTranslation from './supportedLanguages/yo-NG.json';
import yoBJTranslation from './supportedLanguages/yo-BJ.json';
import zhHKTranslation from './supportedLanguages/zh-HK.json';
import chuukeseTranslation from './supportedLanguages/chk.json';

const resources = {
  // Base languages
  [SupportedLanguages.ENGLISH]: { translation: enTranslation },
  [SupportedLanguages.AMHARIC]: { translation: amTranslation },
  [SupportedLanguages.ARABIC]: { translation: arTranslation },
  [SupportedLanguages.BENGALI]: { translation: bnTranslation },
  [SupportedLanguages.GERMAN]: { translation: deTranslation },
  [SupportedLanguages.GREEK]: { translation: elTranslation },
  [SupportedLanguages.SPANISH]: { translation: esTranslation },
  [SupportedLanguages.PERSIAN]: { translation: faTranslation },
  [SupportedLanguages.FRENCH]: { translation: frTranslation },
  [SupportedLanguages.GUJARATI]: { translation: guTranslation },
  [SupportedLanguages.HEBREW]: { translation: heTranslation },
  [SupportedLanguages.HINDI]: { translation: hiTranslation },
  [SupportedLanguages.HMONG]: { translation: hmnTranslation },
  [SupportedLanguages.HAITIAN_CREOLE]: { translation: htTranslation },
  [SupportedLanguages.ARMENIAN]: { translation: hyTranslation },
  [SupportedLanguages.ITALIAN]: { translation: itTranslation },
  [SupportedLanguages.JAPANESE]: { translation: jaTranslation },
  [SupportedLanguages.KHMER]: { translation: kmTranslation },
  [SupportedLanguages.KOREAN]: { translation: koTranslation },
  [SupportedLanguages.BURMESE]: { translation: myTranslation },
  [SupportedLanguages.DUTCH]: { translation: nlTranslation },
  [SupportedLanguages.OROMO]: { translation: omTranslation },
  [SupportedLanguages.PUNJABI]: { translation: paTranslation },
  [SupportedLanguages.POLISH]: { translation: plTranslation },
  [SupportedLanguages.PASHTO]: { translation: psTranslation },
  [SupportedLanguages.PORTUGUESE]: { translation: ptTranslation },
  [SupportedLanguages.ROMANIAN]: { translation: roTranslation },
  [SupportedLanguages.RUSSIAN]: { translation: ruTranslation },
  [SupportedLanguages.SOMALI]: { translation: soTranslation },
  [SupportedLanguages.SWAHILI]: { translation: swTranslation },
  [SupportedLanguages.TAMIL]: { translation: taTranslation },
  [SupportedLanguages.THAI]: { translation: thTranslation },
  [SupportedLanguages.TAGALOG]: { translation: tlTranslation },
  [SupportedLanguages.TURKISH]: { translation: trTranslation },
  [SupportedLanguages.UKRAINIAN]: { translation: ukTranslation },
  [SupportedLanguages.URDU]: { translation: urTranslation },
  [SupportedLanguages.VIETNAMESE]: { translation: viTranslation },
  [SupportedLanguages.YIDDISH]: { translation: yiTranslation },
  [SupportedLanguages.YORUBA]: { translation: yoTranslation },
  [SupportedLanguages.CHINESE_SIMPLIFIED]: { translation: zhCNTranslation },
  [SupportedLanguages.CHINESE_TRADITIONAL]: { translation: zhTWTranslation },

  // Country-specific variants
  [SupportedLanguages.AMHARIC_ETHIOPIA]: { translation: amETTranslation },
  [SupportedLanguages.ARABIC_UAE]: { translation: arAETranslation },
  [SupportedLanguages.ARABIC_SAUDI_ARABIA]: { translation: arSATranslation },
  [SupportedLanguages.BULGARIAN_BULGARIA]: { translation: bgBGTranslation },
  [SupportedLanguages.BENGALI_BANGLADESH]: { translation: bnBDTranslation },
  [SupportedLanguages.BOSNIAN_BOSNIA_HERZEGOVINA]: { translation: bsBATranslation },
  [SupportedLanguages.CZECH_CZECH_REPUBLIC]: { translation: csCZTranslation },
  [SupportedLanguages.WELSH_UK]: { translation: cyGBTranslation },
  [SupportedLanguages.DANISH_DENMARK]: { translation: daDKTranslation },
  [SupportedLanguages.GERMAN_AUSTRIA]: { translation: deATTranslation },
  [SupportedLanguages.GERMAN_SWITZERLAND]: { translation: deCHTranslation },
  [SupportedLanguages.GERMAN_GERMANY]: { translation: deDETranslation },
  [SupportedLanguages.GREEK_GREECE]: { translation: elGRTranslation },
  [SupportedLanguages.ENGLISH_AUSTRALIA]: { translation: enAUTranslation },
  [SupportedLanguages.ENGLISH_CANADA]: { translation: enCATranslation },
  [SupportedLanguages.ENGLISH_UK]: { translation: enGBTranslation },
  [SupportedLanguages.ENGLISH_IRELAND]: { translation: enIETranslation },
  [SupportedLanguages.ENGLISH_NEW_ZEALAND]: { translation: enNZTranslation },
  [SupportedLanguages.ENGLISH_US]: { translation: enUSTranslation },
  [SupportedLanguages.SPANISH_ARGENTINA]: { translation: esARTranslation },
  [SupportedLanguages.SPANISH_COLOMBIA]: { translation: esCOTranslation },
  [SupportedLanguages.SPANISH_SPAIN]: { translation: esESTranslation },
  [SupportedLanguages.SPANISH_MEXICO]: { translation: esMXTranslation },
  [SupportedLanguages.SPANISH_US]: { translation: esUSTranslation },
  [SupportedLanguages.ESTONIAN_ESTONIA]: { translation: etEETranslation },
  [SupportedLanguages.PERSIAN_IRAN]: { translation: faIRTranslation },
  [SupportedLanguages.FINNISH_FINLAND]: { translation: fiFITranslation },
  [SupportedLanguages.FRENCH_CANADA]: { translation: frCATranslation },
  [SupportedLanguages.FRENCH_FRANCE]: { translation: frFRTranslation },
  [SupportedLanguages.IRISH_IRELAND]: { translation: gaIETranslation },
  [SupportedLanguages.GUJARATI_INDIA]: { translation: guINTranslation },
  [SupportedLanguages.HEBREW_ISRAEL]: { translation: heILTranslation },
  [SupportedLanguages.HINDI_INDIA]: { translation: hiINTranslation },
  [SupportedLanguages.CROATIAN_CROATIA]: { translation: hrHRTranslation },
  [SupportedLanguages.HATIAN_CREOLE_HAITI]: { translation: htHTTranslation },
  [SupportedLanguages.HUNGARIAN_HUNGARY]: { translation: huHUTranslation },
  [SupportedLanguages.ARMENIAN_ARMENIA]: { translation: hyAMTranslation },
  [SupportedLanguages.INDONESIAN_INDONESIA]: { translation: idIDTranslation },
  [SupportedLanguages.ICELANDIC_ICELAND]: { translation: isISTranslation },
  [SupportedLanguages.ITALIAN_ITALY]: { translation: itITTranslation },
  [SupportedLanguages.JAPANESE_JAPAN]: { translation: jaJPTranslation },
  [SupportedLanguages.GEORGIAN_GEORGIA]: { translation: kaGETranslation },
  [SupportedLanguages.KHMER_CAMBODIA]: { translation: kmKHTranslation },
  [SupportedLanguages.KOREAN_SOUTH_KOREA]: { translation: koKRTranslation },
  [SupportedLanguages.LITHUANIAN_LITHUANIA]: { translation: ltLTTranslation },
  [SupportedLanguages.LATVIAN_LATVIA]: { translation: lvLVTranslation },
  [SupportedLanguages.MALAY_MALAYSIA]: { translation: msMYTranslation },
  [SupportedLanguages.MALTESE_MALTA]: { translation: mtMTTranslation },
  [SupportedLanguages.BURMESE_MYANMAR]: { translation: myMMTranslation },
  [SupportedLanguages.DUTCH_BELGIUM]: { translation: nlBETranslation },
  [SupportedLanguages.DUTCH_NETHERLANDS]: { translation: nlNLTranslation },
  [SupportedLanguages.NORWEGIAN_NORWAY]: { translation: noNOTranslation },
  [SupportedLanguages.PUNJABI_INDIA]: { translation: paINTranslation },
  [SupportedLanguages.POLISH_POLAND]: { translation: plPLTranslation },
  [SupportedLanguages.PASHTO_AFGHANISTAN]: { translation: psAFTranslation },
  [SupportedLanguages.PORTUGUESE_BRAZIL]: { translation: ptBRTranslation },
  [SupportedLanguages.PORTUGUESE_PORTUGAL]: { translation: ptPTTranslation },
  [SupportedLanguages.ROMANIAN_ROMANIA]: { translation: roROTranslation },
  [SupportedLanguages.RUSSIAN_RUSSIA]: { translation: ruRUTranslation },
  [SupportedLanguages.SLOVAK_SLOVAKIA]: { translation: skSKTranslation },
  [SupportedLanguages.SLOVENIAN_SLOVENIA]: { translation: slSITranslation },
  [SupportedLanguages.SOMALI_SOMALIA]: { translation: soSOTranslation },
  [SupportedLanguages.ALBANIAN_ALBANIA]: { translation: sqALTranslation },
  [SupportedLanguages.SERBIAN_SERBIA]: { translation: srRSTranslation },
  [SupportedLanguages.SWEDISH_SWEDEN]: { translation: svSETranslation },
  [SupportedLanguages.SWAHILI_KENYA]: { translation: swKETranslation },
  [SupportedLanguages.TAMIL_INDIA]: { translation: taINTranslation },
  [SupportedLanguages.THAI_THAILAND]: { translation: thTHTranslation },
  [SupportedLanguages.TAGALOG_PHILIPPINES]: { translation: tlPHTranslation },
  [SupportedLanguages.TURKISH_TURKEY]: { translation: trTRTranslation },
  [SupportedLanguages.UKRAINIAN_UKRAINE]: { translation: ukUATranslation },
  [SupportedLanguages.URDU_PAKISTAN]: { translation: urPKTranslation },
  [SupportedLanguages.VIETNAMESE_VIETNAM]: { translation: viVNTranslation },
  [SupportedLanguages.YORUBA_NG]: { translation: yoNGTranslation },
  [SupportedLanguages.YORUBA_BJ]: { translation: yoBJTranslation },
  [SupportedLanguages.CHINESE_HONG_KONG]: { translation: zhHKTranslation },
  [SupportedLanguages.CHUUKEESE]: { translation: chuukeseTranslation },
};

i18n.use(initReactI18next).init({
  fallbackLng: SupportedLanguages.ENGLISH_US,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

export default i18n;
